var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{staticClass:"product-rich-text-editor",attrs:{"editor-toolbar":_vm.toolbar,"placeholder":_vm.placeholder},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }